var _defs, _g, _g2, _path, _path2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartBlack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 749.999995",
    height: 32,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "19b21b6af3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 375 0 C 167.894531 0 0 167.894531 0 375 C 0 582.105469 167.894531 750 375 750 C 582.105469 750 750 582.105469 750 375 C 750 167.894531 582.105469 0 375 0 Z M 375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5256f764b1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 163.179688 239.046875 L 586.851562 239.046875 L 586.851562 603.675781 L 163.179688 603.675781 Z M 163.179688 239.046875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "264f7d377b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 251 108.84375 L 497 108.84375 L 497 335 L 251 335 Z M 251 108.84375 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#19b21b6af3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -75,
    width: 900,
    fill: "#34303e",
    y: -74.999999,
    height: 899.999994,
    fillOpacity: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5256f764b1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 199.585938 239.460938 L 550.511719 239.460938 C 554.667969 239.460938 558.0625 242.75 558.234375 246.867188 L 586.820312 595.3125 L 586.832031 595.3125 C 587.179688 599.5625 584.011719 603.304688 579.757812 603.648438 C 579.542969 603.664062 579.324219 603.675781 579.113281 603.675781 L 170.914062 603.675781 C 166.640625 603.675781 163.179688 600.214844 163.179688 595.941406 C 163.179688 595.617188 163.199219 595.296875 163.238281 594.980469 L 191.824219 246.59375 L 199.527344 247.195312 L 191.820312 246.5625 C 192.15625 242.5 195.574219 239.429688 199.585938 239.460938 Z M 543.394531 254.925781 L 206.640625 254.925781 L 179.296875 588.210938 L 570.738281 588.210938 L 543.394531 254.925781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 487.914062 305.429688 C 496.246094 305.429688 503 312.1875 503 320.519531 C 503 328.851562 496.246094 335.605469 487.914062 335.605469 C 479.582031 335.605469 472.824219 328.851562 472.824219 320.519531 C 472.824219 312.1875 479.582031 305.429688 487.914062 305.429688 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 262.121094 305.429688 C 270.453125 305.429688 277.207031 312.1875 277.207031 320.519531 C 277.207031 328.851562 270.453125 335.605469 262.121094 335.605469 C 253.789062 335.605469 247.03125 328.851562 247.03125 320.519531 C 247.03125 312.1875 253.789062 305.429688 262.121094 305.429688 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#264f7d377b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 251.589844 326.613281 C 251.589844 330.886719 255.050781 334.347656 259.324219 334.347656 C 263.589844 334.347656 267.050781 330.886719 267.050781 326.613281 C 267.050781 228.515625 295.371094 166.152344 331.625 139.234375 C 345.019531 129.28125 359.488281 124.304688 373.898438 124.304688 C 388.304688 124.304688 402.773438 129.28125 416.167969 139.234375 C 452.421875 166.152344 480.742188 228.507812 480.742188 326.613281 C 480.742188 330.886719 484.203125 334.347656 488.476562 334.347656 C 492.742188 334.347656 496.203125 330.886719 496.203125 326.613281 C 496.203125 223.082031 465.125 156.390625 425.351562 126.847656 C 409.183594 114.847656 391.570312 108.84375 373.898438 108.84375 C 356.222656 108.84375 338.609375 114.847656 322.441406 126.847656 C 282.667969 156.390625 251.589844 223.082031 251.589844 326.613281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBlack2);
export default __webpack_public_path__ + "static/media/cart_black2.92421ecf6b82eb5d8cf487c4de605850.svg";
export { ForwardRef as ReactComponent };